import React, { useState } from 'react';
import useStyles from './styles';
import { Card, Button, Typography, Box, Avatar, Link, Checkbox, } from '@material-ui/core';

const PeopleList = ({
    isData,
    profileData,
    contactId,
    cursor,
    findResult,
    selectedPeople,
    setSelectedPeople,
    addToBixjet,
    updateContact
}) => {
    const classes = useStyles();

    const handleSelectChange = (event, people) => {
        if (event.target.checked) {
            setSelectedPeople([...selectedPeople, people]);
        } else {
            setSelectedPeople(selectedPeople.filter(person => person.id !== people.id));
        }
    };


    return (
        <Box display="flex" flexDirection="column" style={{ width: contactId ? '90%' : '50%', margin: 'auto', alignItems: contactId || isData ? 'normal' : 'flex-end' }}>
            {selectedPeople.length > 0 && (
                <Button
                    size='small'
                    color='primary'
                    variant='contained'
                    style={{ float: 'right', marginTop: 5, width: '150px' }}
                    onClick={() => addToBixjet()}
                >
                    Add To Contact
                </Button>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {profileData?.length > 0 ? (
                    <Box mt={2} className={classes.box2}>
                        {profileData.map((invitation, index) => (
                            <Card key={index} style={{ padding: '5px 0px', margin: '4px 5px', borderRadius: '5px' }}>
                                <Box display="flex">
                                    {!contactId && (
                                        <Checkbox
                                            checked={selectedPeople.find((a) => a.id === invitation.id)}
                                            onChange={(event) => handleSelectChange(event, invitation)}
                                            color="primary"
                                        />
                                    )}
                                    <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: '100%', padding: contactId ? '0px 10px' : '0px' }}>
                                        <Box display="flex" alignItems="center" style={{ gap: 10 }}>
                                            {invitation.profile_picture_url ? (
                                                <img
                                                    src={invitation.profile_picture_url}
                                                    style={{
                                                        width: 50, height: 50,
                                                        borderRadius: 50
                                                    }}
                                                />
                                            ) : (
                                                <Avatar alt="Profile" style={{ fontSize: 18, color: '#005eb2', fontWeight: 'bold', textTransform: 'uppercase', width: 50, height: 50 }}>
                                                    {`${invitation.name?.charAt(0) ? invitation.name?.charAt(0) : ''}${invitation.name.split(' ')?.[1]?.charAt(0) ? invitation.name.split(' ')?.[1]?.charAt(0) : ''}`}
                                                </Avatar>
                                            )}
                                            <Box>
                                                <Link target="_blank" href={`https://www.linkedin.com/in/${invitation.public_identifier}`}>
                                                    <Typography variant='body1'>{invitation.name}</Typography>
                                                </Link>
                                                <Typography variant='body2'>{invitation.headline}</Typography>
                                            </Box>
                                        </Box>
                                        {contactId && (
                                            <Button
                                                color='primary'
                                                size='small'
                                                variant='contained'
                                                onClick={() => updateContact(invitation)}
                                            >
                                                Update
                                            </Button>
                                        )}
                                    </Box>
                                </Box>
                            </Card>
                        ))}
                    </Box>
                ) : isData && (
                    <Typography variant='h6' style={{ marginTop: 10 }}>Data Not Found Please try again</Typography>
                )}
                {(cursor && profileData?.length > 0) && (
                    <Button
                        color='primary'
                        variant='outlined'
                        size='medium'
                        style={{
                            marginTop: '10px',
                            borderRadius: '16px',
                            border: '1px solid #005EB2'
                        }}
                        onClick={() => {
                            findResult(cursor);
                        }}
                    >
                        See More Results
                    </Button>
                )}
            </div>
        </Box>
    );
};

export default PeopleList;
